import React, { SVGProps } from 'react'
const SvgUnsplit = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox='0 0 18 18'
    aria-hidden="true"
    fill='none'
    {...props}
  >
    <path d="M2.18182 6.54532H12C13.8075 6.54532 15.2727 8.01057 15.2727 9.81805C15.2727 11.6255 13.8075 13.0908 12 13.0908H8.72728M2.18182 6.54532L5.09091 3.63623M2.18182 6.54532L5.09091 9.45441"
      stroke="#4489F9"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgUnsplit
